module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.5d6f50ed.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Bold.otf
 ** module id = 1333
 ** module chunks = 0
 **/